import './bootstrap';
import './gallery';

import 'owl.carousel2';

// import { addBackToTop } from "vanilla-back-to-top";
import calendar from './calendar';

import Vue from 'vue';
import VueCarousel from 'vue-carousel';
Vue.use(VueCarousel);

/**
 * Base site class
 */
let Site = function () {

    /**
    * Init scroll down
    */
    let initScrollToBottom = function () {

        $(".scroll-down").click(function () {
            $("html, body").animate({ scrollTop: $(document).height() }, 1000);
        });

    };

    /**
     * Init scroll up
     */
    let initScrollToTop = function () {

        $(".scroll-up").click(function () {
            $("html, body").animate({ scrollTop: 0 }, 1000);
        });

    };

    onclick = 'window.scrollBy({ top: window.outerHeight,behavior : "smooth" })'

    let initMenu = function () {
        let menu = document.querySelector('.menu');
        let nav = document.querySelector('.primary-nav');
        menu.addEventListener('click', function () {
            nav.classList.toggle('open');
        });
    };

    let initShrinkMenu = function () {
        let body = document.querySelector('body');
        let header = document.getElementById('header');
        let logoWrapper = document.getElementById('logo-wrapper');
        let logo = document.getElementById('logo');
        let logoLink = document.getElementById('logo-link');
        let social = document.getElementById('social');
        let logoSvg = document.querySelector('#logo-link svg');
        let nav = document.querySelector('.primary-nav ul');

        let centerPosition = logo.offsetWidth / 2 - logoLink.offsetWidth / 2;

        window.addEventListener('scroll', () => {
            let topPos = document.documentElement.scrollTop;

            if (topPos === 0 && window.innerWidth >= 768) {
                body.style.paddingTop = '248px';
            } else {
                body.style.paddingTop = header.offsetHeight + 'px';
            }

            if (topPos < 50 && window.innerWidth >= 768) {

                let percent = 2 * topPos * 0.01;
                logo.classList.remove("text-center");
                logoWrapper.style.height = (110 - topPos) + 'px';

                if (window.innerWidth >= 992) {
                    header.style.paddingTop = 3 - ( percent * 2 )  + 'rem';
                }
                logoWrapper.style.marginBottom = 3 - ( percent * 2 )  + 'rem';

                logoLink.style.left = centerPosition - (centerPosition * percent) + "px";

                logoSvg.style.width = 306 - (156 * percent);
                nav.style.height = 42 - (42 * percent) + "px";
                social.style.bottom = 18 * percent + 'px';

            } else {

                if (window.innerWidth < 768) {
                    header.style.paddingTop = '0.5rem';
                    logoWrapper.style.marginBottom = '0.5rem';
                } else {
                    header.style.paddingTop = '1rem';
                    logoWrapper.style.marginBottom = '1rem';
                }

                logoWrapper.style.height = '60px';
                logo.classList.remove("text-center");
                logoLink.style.left = '0px';
                logoSvg.style.width = "150px";
                nav.style.height = '0px';
                social.style.bottom = '18px';
                body.style.paddingTop = '92px';
            }
        });
    };

    let initSearch = function () {
        let icon = document.querySelector('.search-icon');
        let header = document.querySelector('.search-form');
        let input = document.querySelector('.search-form input');

        icon.addEventListener('click', function (e) {
            if (header.classList.contains('open')) {
                header.classList.remove('open');
            } else {
                header.classList.add('open');
                input.focus();
            }
        });

    };

    let initOwlCarousel = function () {
        $('.owl-carousel-books').owlCarousel({
            loop: true,
            margin: 20,
            responsiveClass: true,
            navText: [
                `<svg class="arrow next" width="14" height="42" viewBox="0 0 14 42" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.2002 1.7998L0.200195 21.0759L12.2002 40.1998" stroke="#00B9F0" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
                `<svg class="arrow prev" width="14" height="42" viewBox="0 0 14 42" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.2002 40.2002L13.2002 20.9241L1.2002 1.80019" stroke="#00B9F0" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>`
            ],
            responsive: {
                0: {
                    items: 1,
                    nav: true
                },
                600: {
                    items: 2,
                    nav: true,
                },
                900: {
                    items: 3,
                    nav: true,
                },
                1270: {
                    items: 4,
                    nav: true,
                    loop: false
                }
            }
        });
    };


    let initCalendar = function () {

        if (typeof events == 'undefined' && typeof categories == 'undefined') {
            return;
        }

        let calendarEvents = events.map(function (event) {
            return {
                'FromDate': new Date(event.event_from_clean),
                'ToDate': new Date(event.event_to_clean),
                'Title': event.title,
                'Link': event.link,
                'CategoryId': event.category_id,
            };
        });

        $(".calendar").each(function () {
            calendar(this, calendarEvents, {
                'eventsWithAjax': typeof eventsWithAjax != 'undefined' ? eventsWithAjax : false
            }, categories);
        });
    };

    let initEventDatePicker = function () {

        if (document.querySelector('#event-datepicker') == null) {
            return;
        }

        $("#filter-calendar").each(function () {
            calendar(this, {
                DateTimeFormat: 'yyyy',
            }, {
                IsEventCalendar: true
            });
        });

        let datepicker = document.querySelector('#event-datepicker .datepicker');
        let trigger = document.querySelector('#event-datepicker .trigger');
        let event_from = document.querySelector('#event_from');
        let event_to = document.querySelector('#event_to');

        let focusedInput = 'event_from';

        trigger.addEventListener("click", function () {
            if (datepicker.classList.contains('d-none')) {
                datepicker.classList.remove('d-none');
            } else {
                datepicker.classList.add('d-none');
            }
        });

        event_from.addEventListener("click", function () {
            focusedInput = 'event_from';
            event_to.classList.remove('focus');
            event_from.classList.add('focus');
        });
        event_to.addEventListener("click", function () {
            focusedInput = 'event_to';
            event_from.classList.remove('focus');
            event_to.classList.add('focus');
        });
    };

    return {
        /**
         * main function to initiate the module
         */
        init: function () {
            initMenu();
            initScrollToBottom();
            initScrollToTop();
            initSearch();
            initOwlCarousel();
            initCalendar();
            initShrinkMenu();
            initEventDatePicker();
        },
    };

}();

/**
 * Init site js
 */
$(document).ready(function () {
    Site.init();
});

new Vue({
    el: '#app',
});
